import React, { useEffect, useState } from "react";
import { Link } from "@StarberryUtils";
import ScrollAnimation from "react-animate-on-scroll";
import { Button, Form, Container, FormControl, Row, InputGroup, Col, Dropdown } from "react-bootstrap";
import "./StaticPageBanner.scss";
import ReactMarkdown from "react-markdown"
import { Reviews_Page_Url } from "@Components/common/site/constants";
import StaticPageBannerDesktop from "../../../images/StaticPage/static-page-banner-d.jpg";
import StaticPageBannerTablet from "../../../images/StaticPage/static-page-banner-t.jpg";
import StaticPageBannerMobile from "../../../images/StaticPage/static-page-banner-m.jpg";
import axios from "axios"
import wordsToNumbers from 'words-to-numbers';

import GoogleBannerDesktop from "../../../images/StaticPage/google-reviews-white-d.png";
import GoogleBannerTablet from "../../../images/StaticPage/google-reviews-white-t.png"
import GoogleBannerMobile from "../../../images/StaticPage/google-reviews-white-m.png"

import GetURL from '@Components/common/site/get-url';
import ImageTransform from "@Components/common/ggfx-client/module/components/image-transform";

import { inViewOptions } from '../../../Components/utils/animations';
import { motion } from "framer-motion";
import { InView } from "react-intersection-observer";
import { ElfsightWidget } from 'react-elfsight-widget';
import {ImageModule} from "@Components/common/Image_Module";

const containerVariants = {
    hidden: {
        opacity: 0
    },
    visible: {
        opacity: 1,
        transition: {
            staggerChildren: 0.4,
            ease: [0.33, 1, 0.68, 1],
            duration: 0.4
        }
    }
}

const titleVariants = {
    hidden: {
        opacity: 0,
        y: 40
    },
    visible: {
        opacity: 1,
        y: 0,
        transition: {
            ease: [0.33, 1, 0.68, 1],
            duration: 1
        }
    }
}

const contentVariants = {
    hidden: {
        opacity: 0,
        y: 40
    },
    visible: {
        opacity: 1,
        y: 0,
        delay: 0.4,
        transition: {
            ease: [0.33, 1, 0.68, 1],
            duration: 1
        }
    }
}

const StaticPageBanner = (props) => {
    const [testimonials, setTestimonials] = useState([])
    const getitems = async url => {
        try {
            const { data } = await axios.get(url, {
                headers: {
                Authorization: `Bearer ${process.env.GATSBY_STRAPI_FORM_TOKEN}`,
                }
            })// could be from env files
            setTestimonials(data)
        } catch (error) {
            // cache it if fail/error;
            console.error(error)
        }
    }
    useEffect(() => {

        let url = `${process.env.GATSBY_STRAPI_SRC}/google-review-reviews`
        getitems(url);
    }, [])
    var testimonial_count = testimonials ? testimonials.length : 0;
    var rating_count = 0;
    testimonials && testimonials.length > 0 && testimonials.map((item, ind) => {
        rating_count += parseInt(wordsToNumbers(item.starRating));
    })
    var rating_avg = rating_count / testimonial_count;
    let processedImages = JSON.stringify({});
    if (props.data?.imagetransforms?.Image_Transforms) {
        processedImages = props.data.imagetransforms.Image_Transforms;
    }
    return (
        <InView {...inViewOptions}>
            {({ ref, inView }) => {
                return (
                    <motion.section
                        ref={ref}
                        initial="hidden"
                        animate={inView ? "visible" : "hidden"}
                        variants={containerVariants}
                    >
                        <React.Fragment>
                            {/* {props.data?.Banner_Image?.url}
                            {JSON.stringify(props.data.id)} */}
                            <section className="static-page-banner">
                                <div className="static-page-banner-wrapper">
                                    {/* <picture>
                                        <source
                                            media="(min-width:992px)"
                                            srcSet={props.data.Banner_Image?.url}
                                        />
                                        <source
                                            media="(min-width:768px)"
                                            srcSet={props.data.Banner_Image?.url}
                                        />
                                        <img src={props.data.Banner_Image?.url} alt={props.data.Banner_Image?.alternativeText} />
                                    </picture> */}
                                    <ImageModule ImageSrc={props.data?.Banner_Image} attr={{ alt: props.data.Banner_Image?.alternativeText }} ggfx_results={props.data.ggfx_results} imagename="page.Image.bannerImg" strapi_id={props.data.id} />

                                    {/* <ImageTransform imagesources={props.data?.Banner_Image?.url} renderer="srcSet" imagename='page.Image.bannerImg'
                                        attr={{ alt: props.data.Banner_Image?.alternativeText, className: '' }}
                                        imagetransformresult={processedImages} id={props.data.id} >

                                    </ImageTransform> */}
                                </div>
                                <div className="static-page-banner-content">
                                    <Container>
                                        <ScrollAnimation animateIn='fadeInUp' animateOnce={true}>
                                            <ScrollAnimation animateOnce={true} animateIn="fadeIn">
                                                <h1>{props?.data?.Banner_Title}</h1>
                                                <ReactMarkdown source={props?.data?.Banner_Content} allowDangerousHtml />
                                            </ScrollAnimation>
                                            <div className="banner-button-group d-none d-lg-flex">
                                                {props.data?.CTA_Links?.CTA_Btn_Label1 === "Current Vacancies" ?
                                                    <ScrollAnimation animateOnce={true} animateIn="fadeIn">

                                                        <a onClick={props.executeScroll} className="btn btn-primary">{props.data?.CTA_Links?.CTA_Btn_Label1}</a>
                                                    </ScrollAnimation>
                                                    :
                                                    <ScrollAnimation animateOnce={true} animateIn="fadeIn">
                                                        <GetURL class="btn-primary btn" label={props.data?.CTA_Links?.CTA_Btn_Label1} alias={props.data?.CTA_Links?.CTA_Url1?.URL} />
                                                    </ScrollAnimation>
                                                }
                                                <ScrollAnimation animateOnce={true} animateIn="fadeIn">
                                                    <GetURL class="btn btn-outline" label={props.data?.CTA_Links?.CTA_Btn_Label2} alias={props.data?.CTA_Links?.CTA_Url2?.URL} />
                                                </ScrollAnimation>

                                            </div>
                                            <div className="elfsightWidget-class">
                                                <ElfsightWidget widgetId="73ebc99a-be23-4a6a-8521-2741e3a6e19a" lazy />
                                            </div>
                                        </ScrollAnimation>
                                    </Container>
                                </div>
                            </section>
                        </React.Fragment>
                    </motion.section>
                )
            }}
        </InView>
    )
}

export default StaticPageBanner;